import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config       from '@/config';

export const networkConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/network`,
});

export default class NetworkServiceModel extends ApiModel {
	public static get connector() {
		return networkConnector;
	}

	public static serviceName = 'network';
	public static partitionName = 'jts';
}
